import { render, staticRenderFns } from "./DefaultLayoutSidebar.vue?vue&type=template&id=42e823c4&scoped=true&"
import script from "./DefaultLayoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayoutSidebar.vue?vue&type=style&index=0&id=42e823c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e823c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VNavigationDrawer})
